import { inject } from '@angular/core';
import { CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

/**
 * Allows any authenticated role except `guest`. Guest accounts are limited to
 * the dataset catalogue and live inference (which use `authGuard` only).
 */
export const memberGuard: CanActivateFn = async (_route, state: RouterStateSnapshot) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isLoggedIn) {
    auth.saveRedirect(state.url);
    return router.createUrlTree(['/login']);
  }

  const valid = await auth.validateToken();
  if (!valid) {
    auth.saveRedirect(state.url);
    return router.createUrlTree(['/login']);
  }

  if (!auth.isMember) return router.createUrlTree([auth.homeRoute()]);
  return true;
};
